<template>
    <figure class="image is-1by1" :class="{ 'transition-up move-up-on-hover': !this.isMobile && !this.isTablet }">
        <div onclick="window.open('https://blution.de', '_blank')" class="pointer-hand">
            <img src="/img/referenzen-blution.png" alt="b.lution AG">
        </div>
    </figure>
</template>

<script>
    export default {
        name: 'Referenzen-Kunden-2',
        props: [
            'isMobile',
            'isTablet',
        ],
    }
</script>
